import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import PeopleIcon from "@mui/icons-material/People";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import type {SvgIconProps} from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import Humanize from "humanize-plus";
import type {ComponentType} from "react";

/**
 * Mirror of the main app's `SimpleCounter` (icon + humanized count + pluralized
 * label), reduced to the variants the search cards need. Hidden when the count
 * is missing or negative, matching production.
 */
function Counter(props: {count?: number; label: string; Icon: ComponentType<SvgIconProps>}) {
    const {count, label, Icon} = props;
    if (count == null || count < 0) {
        return null;
    }

    return (
        <Typography
            color="text.secondary"
            variant="body2"
            sx={{display: "flex", alignItems: "center", gap: 0.5, fontWeight: 700}}
        >
            <Icon sx={{fontSize: 16, width: 16, height: 16}} />
            <span>
                {Humanize.compactInteger(count, 1)} {Humanize.pluralize(count, label)}
            </span>
        </Typography>
    );
}

export const FollowerCounter = (props: {count?: number}) => (
    <Counter count={props.count} label="Follower" Icon={PeopleIcon} />
);
export const ProjectCounter = (props: {count?: number}) => (
    <Counter count={props.count} label="Project" Icon={FolderOpenIcon} />
);
export const UsageCounter = (props: {count?: number}) => (
    <Counter count={props.count} label="Use" Icon={ShowChartIcon} />
);
export const CommentCounter = (props: {count?: number}) => (
    <Counter count={props.count} label="Comment" Icon={ModeCommentOutlinedIcon} />
);
export const StarCounter = (props: {count?: number}) => (
    <Counter count={props.count} label="Star" Icon={StarBorderIcon} />
);
